(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-collection"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function() {
    $('.home_category_slider').slick({
      dots: false,
      infinite: true,
      arrows:true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },{
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },{
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["training-solution"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function() {
	if ( window.innerWidth < 700 ) {
    document.querySelector(".solution-set").classList.add('enable-slide');
}
    $('.enable-slide').slick({
      dots: false,
      infinite: true,
      arrows:true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
	    {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  });

  } catch(e) { console.error(e); }
})();
})();
